import { connect } from 'react-redux';

import { getPropertyPriceLabel } from '../../../modules/configuration/selectors';
import { hasSelectedEnterpriseNetPricing } from '../../../selectors/views/selectedEnterprise/selectedEnterprise';
import { ApplicationState } from '../../../types';

export const inject = connect(
    (state: ApplicationState) => ({
        hasNetPricing: hasSelectedEnterpriseNetPricing(state, {}),
        priceLabel: getPropertyPriceLabel(state),
    }),
    {}
);
